module.exports = __webpack_public_path__ + "static/media/eddys-banner.17cfdc15.jpg";